// extracted by mini-css-extract-plugin
module.exports = {"MarketplaceItemDescriptionTab":"MarketplaceItemDescriptionTab_MarketplaceItemDescriptionTab__2BEAn"};